module.exports = __webpack_public_path__ + "static/img/logo_kitty_blue.9141cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_kitty_blue.png
// module id = nbTT
// module chunks = 19